import { getConfig } from "../config";
function getAnimationDriver() {
  return getConfig().animations;
}
export {
  getAnimationDriver
};
//# sourceMappingURL=getAnimationDriver.js.map
